import { publicFileHost, wuyePublicFileHost } from "@/config/app";

export const getImagePre = (fileId: number | string): string => {
  if (!fileId) {
    return "";
  }
  if (fileId.toString().indexOf("http") === 0) {
    return fileId.toString();
  }
  return `${publicFileHost}/${fileId}`;
}

export const getServerFile = (fileId: number | string): string => {
  return `${getImagePre(fileId)}`;
}

export const getWuyeServerFile = (fileId: number | string): string => {
  if (!fileId) {
    return "";
  }
  if (fileId.toString().indexOf("http") === 0) {
    return fileId.toString();
  }
  return `${wuyePublicFileHost}/${fileId}`;
}

export const getImageCover = (fileId: number | string, width: number = 400, quality: number = 100): string => {
  return `${getImagePre(fileId)}?imageView2/2/w/${width}/q/${quality}`;
}
